"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageContext = getPageContext;
exports.trackEvent = trackEvent;
exports.trackIdentifyUser = trackIdentifyUser;
exports.trackGoogleAnalyticsEvent = trackGoogleAnalyticsEvent;
exports.trackGoogleTagManagerEvent = trackGoogleTagManagerEvent;
exports.trackUserCreated = trackUserCreated;
exports.getBusinessCategory = exports.BadgeValue = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

var _storage = require("../util/storage");

var _vendorUtils = require("../marketplace/vendorUtils");

var _vendorTaxonomyKeys = require("../marketplace/vendorTaxonomyKeys");

var _getVendorTaxonomySwi;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BadgeValue;
exports.BadgeValue = BadgeValue;

(function (BadgeValue) {
  BadgeValue["QUICK_RESPONDER"] = "quick_responder";
})(BadgeValue || (exports.BadgeValue = BadgeValue = {}));

function getPageContext() {
  var _window, _window$zola;

  return {
    path: window.location.pathname,
    search: window.location.search,
    referrer: ((_window = window) === null || _window === void 0 ? void 0 : (_window$zola = _window.zola) === null || _window$zola === void 0 ? void 0 : _window$zola.referrer) || document.referrer,
    url: window.location.href,
    title: document.title
  };
} // Incomplete list of event names


/**
 * Guard / gatekeeper to blacklist certain events.
 *
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function canTrack(eventName, payload) {
  if (eventName === 'CTA Viewed') {
    // If we want to allowlist some CTA viewed events, we can do that with the payload
    return false;
  }

  return true;
}

function trackEvent(eventName, payload) {
  var _window2, _window2$analytics;

  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var optionsFinal = options || {};
  optionsFinal.page = getPageContext();

  if ((_window2 = window) !== null && _window2 !== void 0 && (_window2$analytics = _window2.analytics) !== null && _window2$analytics !== void 0 && _window2$analytics.track && canTrack(eventName, payload)) {
    window.analytics.track(eventName, payload, optionsFinal);
  }
}

function trackIdentifyUser(userId, traits, options) {
  var optionsFinal = options || {};
  optionsFinal.page = getPageContext();

  if (window && window.analytics) {
    window.analytics.identify(userId, traits, optionsFinal);
  }
}

/**
 * Sends an event to GA through Segment.  Does not go ot other Segment destinations.
 * https://segment.com/docs/connections/destinations/catalog/google-analytics/#track
 * @param eventName The Event name will become the action in GA
 * @param payload
 */
function trackGoogleAnalyticsEvent(eventName, payload) {
  var options = {
    integrations: {
      All: false,
      'Google Analytics': true
    }
  };
  trackEvent(eventName, payload, options);
}
/**
 * Fires a GTM event.  Does not go to other Segment destinations.
 * @param eventName
 * @param payload payload data will be pushed to the dataLayer
 */


function trackGoogleTagManagerEvent(eventName, payload) {
  var options = {
    integrations: {
      All: false,
      'Google Tag Manager': true
    }
  };
  trackEvent(eventName, payload, options);
}

function getCampaignContext() {
  var _document;

  if ((_document = document) !== null && _document !== void 0 && _document.cookie) {
    var utm_source = (0, _storage.getCookie)('utm_source') || undefined;
    var utm_campaign = (0, _storage.getCookie)('utm_campaign') || undefined;
    var utm_term = (0, _storage.getCookie)('utm_term') || undefined;
    var utm_content = (0, _storage.getCookie)('utm_content') || undefined;
    var utm_medium = (0, _storage.getCookie)('utm_medium') || undefined;
    var hasUtmCookies = [utm_source, utm_campaign, utm_term, utm_content, utm_medium].reduce(function (acc, cur) {
      return acc || Boolean(cur);
    }, false);

    if (hasUtmCookies) {
      return {
        content: utm_content,
        medium: utm_medium,
        name: utm_campaign,
        source: utm_source,
        term: utm_term
      };
    }
  }

  return undefined;
}

function trackUserCreated(email, pkey) {
  var payload = {
    email: email,
    pkey: pkey
  };
  var campaignContext = getCampaignContext();
  var options = campaignContext ? {
    campaign: campaignContext
  } : undefined;
  trackEvent('User Created', payload, options);
}

var getBusinessCategory = (0, _vendorUtils.getVendorTaxonomySwitchFunc)((_getVendorTaxonomySwi = {}, _defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.VENUES_TAXONOMY_KEY, 'VENUE'), _defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.BANDS_DJS_TAXONOMY_KEY, 'MUSICIAN_DJ'), _defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.BAR_SERVICES_TAXONOMY_KEY, 'BAR_SERVICES'), _defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.CAKES_DESSERTS_TAXONOMY_KEY, 'CAKES_DESSERTS'), _defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.CATERING_TAXONOMY_KEY, 'CATERER'), _defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.FLORISTS_TAXONOMY_KEY, 'FLORIST'), _defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.HAIR_MAKEUP_TAXONOMY_KEY, 'HAIR_MAKEUP'), _defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.PHOTOGRAPHERS_TAXONOMY_KEY, 'PHOTOGRAPHER'), _defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.PLANNERS_TAXONOMY_KEY, 'PLANNER'), _defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.VIDEOGRAPHERS_TAXONOMY_KEY, 'VIDEOGRAPHER'), _getVendorTaxonomySwi));
exports.getBusinessCategory = getBusinessCategory;